// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List {
  margin: 0;
  padding: 0;
}
.List > li {
  list-style: none;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/List/List.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,UAAA;AACJ;AACI;EACI,gBAAA;AACR","sourcesContent":[".List {\n    margin: 0;\n    padding: 0;\n\n    & > li {\n        list-style: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
